<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <title>stop</title>
    <path d="M18,18H6V6H18V18Z" />
  </svg>
</template>
